<template>
    <div v-if="viewModel" id="balance" class="container bng-narrow-container bng-balance">
        <div
            v-if="paymentNotification && paymentNotification.id"
            :class="[paymentNotification.cssClass, 'notification']"
            ref="paymentNotification"
        >
            <button class="delete" @click="$refs.paymentNotification.classList.add('is-hidden')"></button>
            {{ $t(`payment system.messages.payment.${paymentNotification.result}`, Object.assign({}, paymentNotification, { type: $t(`payment system.${paymentNotification.type}`) })) }}
        </div>
        <div class="bng-balance-header">
            <div v-if="viewModel.length > 1" class="column-radio"></div>
            <span class="column-balance">{{ "components.pages.balance.balance" | translate }}</span>
            <span class="column-bonus">
                <template v-if="client && client.bonus.anyBonuses">
                    <p class=" is-2">{{ "components.pages.balance.bonus" | translate }}</p>
                    <button
                        type="button"
                        class="empty button bng-bonus-get-link"
                        @click="goToBonusRules()"
                        :title="'components.common.bonus.get bonus' | translate"
                    ></button>
                </template>
            </span>
        </div>
        <template v-if="viewModel.length">
            <div
                v-for="{ balance } of viewModel"
                :key="balance.id"
                :class="['bng-balance-item', {'active': balance.isActive}]"
                @click="switchDefaultBalance(balance.id)"
            >
                <div v-if="viewModel.length > 1" class="column-radio">
                    <span v-if="balance.isActive" class="custom-radio active"></span>
                    <span v-else class="custom-radio"></span>
                </div>
                <div class="column-balance">
                    <div class="bng-balance-value">
                        <span class="bng-balance-value-inner">{{ balance.real | currency(balance.currency) }}</span>
                    </div>
                </div>
                <div v-if="client && client.bonus.anyBonuses" class="column-bonus">
                    <div class="bng-balance-bonus-value">
                        <span class="bng-balance-bonus-value-inner">{{ balance.bonus | currency(balance.currency) }}</span>
                    </div>
                </div>
            </div>
        </template>
        <div
            v-else-if="loaded"
            class="notification is-warning"
        >{{ "components.pages.balance.no balances" | translate }}</div>
        <template v-if="client && client.bonus.anyBonuses">
            <bonus ref="bonus" />
        </template>
    </div>
</template>

<script>
import Vue from 'vue';

import balanceService from '../../../../../../_common/services/balance.service';
import paymentService from '../../../../../../_common/services/payment.service';
import ymService from '../../../../../../_common/services/ym.service';
import gaService from '../../../../../../_common/services/ga.service';

import Description from '../../../common/description/description.vue';
import Bonus from '../../../common/bonus/bonus.vue';

export default {
    name: 'balance',
    components: { Description, Bonus },
    data: () => ({
        viewModel: null,
        loaded: false,
        tempData: null,
        activeBalance: null,
        paymentMethods: null
    }),
    computed: {
        client() {
            return Vue.state.client.get();
        },
        player() {
            return Vue.state.player.get();
        },
        balance() {
            return this.player && this.player.balance;
        },
        balanceReal() {
            return this.balance && this.balance.real;
        },
        paymentNotification: function () {
            const id = this.$route.query.p;
            const result = { t: 'success', f: 'error', e: 'declined' }[this.$route.query.r];
            if (id || result) {
                const type = this.$route.query.t;
                this.tempData = {
                    id,
                    result,
                    type: type,
                    cssClass: (!result && 'is-hidden') || (result === 'success' && 'is-success') || 'is-danger'
                };

                this.$router.replace({ name: this.$route.name, params: this.$route.params });

                ymService.send("reachGoal", `${type.toUpperCase()} ${result.toUpperCase()}`);
                gaService.send("paymentsystem", `ps_${type}_${result}`, `${type}3`);
            }            

            return this.tempData;
        }
    },
    watch: {
        balanceReal() {
            (async () => {
                await this.refresh();
            })();
        }
    },
    async mounted() {
        await this.refresh();
    },
    methods: {
        async refresh() {
            await Vue.state.client.ensure();
            await this.loadViewModel();
            await this.loadPaymentMethods();
        },
        async loadViewModel() {
            this.viewModel = await paymentService.getBalancesViewModel();
            this.setActiveBalance();
            this.loaded = true;
        },
        async switchDefaultBalance(balanceId) {
            const balance = await balanceService.activate(balanceId);
            this.viewModel.forEach((item) => (item.balance.isActive = item.balance.id === balance.id) && (item.balance = balance));
            if (this.$refs.bonus) this.$refs.bonus.refresh();
            await Vue.state.games.reload();
            this.setActiveBalance();
            await this.loadPaymentMethods(balance.currency);
        },
        getCurrency(currencyId) {
            return Vue.state.currencies.getCurrency(currencyId);
        },
        setActiveBalance() {
            this.activeBalance = this.viewModel.map((vm) => vm.balance).find((b) => b.isActive);
        },
        async loadPaymentMethods() {
            let methods = await paymentService.getPaymentMethods(this.activeBalance.id, 'deposit');
            this.paymentMethods = methods.map((m) => this.$t(`payment system.systems.${m.name}.name`)).join(', ');
        },
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/balance/balance.vue